/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

import CLog, { LogTypes } from "./ComponentLogger";
import LocalizationComponent from "../Localization/LocalizationComponent";

// tslint:disable-next-line:class-name
export class CurrencyUtil
{
    public static GetCurrencyString(loc: LocalizationComponent, currencyValue: number): string
    {
        try
        {
            let formatOptions = loc.NumberFormatOptions;
            if (formatOptions.currency == "VCD")
            {
                formatOptions.style = "decimal";
                formatOptions.minimumFractionDigits = 2;
                formatOptions.maximumFractionDigits = 2;
            }
            let numFormat = new Intl.NumberFormat(loc.CultureKey, formatOptions);
            let currencyString: string = numFormat.format(currencyValue);

            if (currencyString[0] === "¤") // number format failed, fallback to USD
            {
                CLog.warn("Currency formatting failed, using USD fallback: " + currencyString, LogTypes.Localization);
                formatOptions.minimumFractionDigits = 2;
                formatOptions.maximumFractionDigits = 2;
                numFormat = new Intl.NumberFormat(loc.CultureKey, formatOptions);
                currencyString = numFormat.format(currencyValue);
                currencyString = currencyString.replace("¤", "$");
            }

            return currencyString;
        }
        catch (ex)
        {
            // tslint:disable-next-line:max-line-length
            CLog.error(`Exception [${ex.name}] - [${ex.message}]: Browser could not toLocaleString culture: [${loc.CultureKey}]`
                + ` and value: [${currencyValue}]`);

            return currencyValue.toString();
        }
    }
}
